<template>
	<div id="activity-type-create">
		<vx-card class="mb-base" title="Form Pasien">
			<vue-form-generator
				tag="div"
				:schema="schema"
				:model="model"
				:options="formOptions"
				@model-updated="listen"
			></vue-form-generator>
		</vx-card>
		<div class="vx-col w-full" vs-justify="center">
			<vs-row vs-w="12" vs-type="flex" vs-justify="center">
				<vs-button
					class="mr-4 mb-4"
					color="danger"
					@click="$router.go(-1)"
					>
					Batal
				</vs-button>
				<vs-button
					class="mr-4 mb-4"
					icon-pack="feather"
					color="#6488e4"
					@click="onConfirm"
					>
					Simpan
				</vs-button>
			</vs-row>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
import ref from "@/api/ref.js";
import form from "@/api/form.js";
import tool from "@/tool/form_tool.js";
import patient from "@/api/patient.js";

export default {
	data() {
		return {
			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			}
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		onConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: `Konfimasi`,
				text: "Anda yakin untuk melanjutkan proses ?",
				acceptText: "Ya",
				cancelText: "Tidak",
				accept: this.submitData
			});
		},
		submitData() {
			let config = {
				headers: {
					"content-type": "application/json"
				}
			};

			patient.savePatient(this.model, config)
				.then(res => {
					if (res.data.status) {
						this.$vs.notify({
							title: "Info",
							time: 3000,
							text: "Data telah berhasil di simpan",
							color: "success",
							position: "top-right"
						});
						this.$router.push(
							"/pasien/list"
						);
					} else {
						this.$vs.notify({
							title: "Terjadi Kesalahan",
							time: 3000,
							text: res.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				})
				.catch(error => {
					if (error.response) {
						this.$vs.notify({
							title: "An Error Occured",
							time: 3000,
							text: error.response.data.message,
							color: "danger",
							position: "top-right"
						});
					}
				});
		},

		async firstLoad() {
			const frm = await form.patient();
			this.schema.fields = frm.data.data[0].fields;
			let idx = this.$route.params.id;
			if (idx) {
				const xmodel = await patient.getDetail(idx);
				this.model = xmodel.data.data[0];
			} else {
				this.model = frm.data.data[0].model;
			}

			await this.getGender();
		},

		async getGender() {
			const gdr = await ref.getGender();
			tool.copyValuesToDropDown(
				this.schema.fields,
				"gender",
				gdr.data.data
			);
		},
	},
	created() {
		this.firstLoad();
	}
};
</script>

<style lang="scss" scoped>
.bordered {
	border-width: 1px;
	border-radius: 4px;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
	margin: 0;
}
.vx-custom-remove-icon {
	text-align: right;
}
.vs-textarea-primary.focusx {
	border: 1px solid #0056a8 !important;
	box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
}
.vs-checkbox-default {
	transform: translate(0, -70%);
	top: 70%;
}
</style>
